
namespace Matrix.Data {

    @Serenity.Decorators.registerClass("Matrix.Data.FieldCustomizationGrid")
    @Serenity.Decorators.editor()
    export class FieldCustomizationGrid extends SiteEntityGrid<FieldCustomizationRow, any> {
        protected getColumnsKey() { return 'Data.FieldCustomization'; }
        protected getDialogType() { return FieldCustomizationDialog; }
        protected getIdProperty() { return FieldCustomizationRow.idProperty; }
        protected getLocalTextPrefix() { return FieldCustomizationRow.localTextPrefix; }
        protected getService() { return FieldCustomizationService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        usePager() {
            return false;
        }

        private _rowCode: string;

        public get rowCode() {
            return this._rowCode;
        }

        public set rowCode(value: string) {
            if (value !== this._rowCode) {
                this._rowCode = value;
                this.setEquality(FieldCustomizationRow.Fields.RowCode, value);
                this.refresh();
            }
        }

        getGridCanLoad() {
            return super.getGridCanLoad() && !!this._rowCode;
        }

        getInitialTitle() {
            return null;
        }

        addButtonClick() {
            if (!this.rowCode)
                return;

            this.editItem(<FieldCustomizationRow>{
                RowCode: this.rowCode
            });
        }
    }
}